import groundcover from '@groundcover/browser';

if (import.meta.env.VITE_STAGE && import.meta.env.VITE_GROUNDCOVER_DSN && import.meta.env.VITE_GROUNDCOVER_API_KEY) {
  groundcover.init({
    apiKey: import.meta.env.VITE_GROUNDCOVER_API_KEY,
    dsn: `https://${import.meta.env.VITE_GROUNDCOVER_DSN}`,
    cluster: import.meta.env.VITE_GROUNDCOVER_CLUSTER,
    environment: import.meta.env.VITE_STAGE,
    appId: 'brandlive-platform',
  });
}
